import { motion } from 'framer-motion';
import Image, { type ImageProps } from 'next/image';
import React, { type CSSProperties } from 'react';

interface MyImageProps {
	settings: {
		style?: CSSProperties;
		classes?: {
			picture?: string;
			image?: string;
		};
		quality?: string;
		width?: string;
		betterBlur?: boolean;
	};
	imageProps: ImageProps;
	title?: string;
	children?: React.ReactNode;
	imageIsLoaded?: () => void;
}

export const ForwardedRefMyImage = React.forwardRef(
	(
		{ settings, imageProps, children, imageIsLoaded }: MyImageProps,
		ref: React.Ref<HTMLPictureElement>,
	) => {
		// Destructuring
		const { classes, betterBlur = true, style } = settings;
		const { picture, image } = classes ?? {};
		const { title, alt, ...restImageProps } = imageProps;

		// States
		const [isLoaded, setIsLoaded] = React.useState(false);

		// Actions
		const onLoadingComplete = () => {
			setIsLoaded(true);
			if (imageIsLoaded) {
				imageIsLoaded();
			}
		};

		return (
			<picture ref={ref} className={picture ?? ''} style={style}>
				{children}
				<Image
					{...restImageProps}
					className={image ?? ''}
					style={
						!isLoaded && betterBlur
							? {
									filter: 'saturate(200%) blur(20px)',
									transform: 'translateZ(0)',
									transition: 'filter 0.1s ease',
							  }
							: {
									transition: 'filter 0.1s ease',
							  }
					}
					sizes={imageProps.fill ? '(max-width: 767px) 70vw, 100vw' : undefined}
					placeholder={imageProps.blurDataURL ? 'blur' : 'empty'}
					onLoadingComplete={onLoadingComplete}
					title={title}
					alt={alt}
				/>
			</picture>
		);
	},
);
export const MyImage = React.memo(ForwardedRefMyImage);
export const MotionMyImage = motion(MyImage);
